import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from '../../../../../utils/methods';

interface StatItem {
  icon: string;
  value: number;
  label: string;
  variant: 'primary' | 'success' | 'warning' | 'info' | 'danger';
}

interface MonthStatCardProps {
  title: string;
  totalRecords: number;
  statItems: StatItem[];
}

const MonthStatCard: React.FC<MonthStatCardProps> = ({ title, totalRecords, statItems }) => {
  const { t } = useTranslation();

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-body">
          <h5 className="mb-3 fw-bold">{title}</h5>
          <div className="row">
          {statItems.map((item, index) => (
            <div key={index} className={`col-sm-${statItems.length === 4 ? '3' : '4'} col-xl-${statItems.length === 4 ? '3' : '4'} d-flex align-items-center`}>
              <div className="avatar">
                <div className={`avatar-initial bg-label-${item.variant} rounded`}>
                  <i className={`${item.icon} icon-24px`}></i>
                </div>
              </div>
              <div className="card-info ms-3">
                <h5 className="mb-0">{formatNumber(item.value)}</h5>
                <p className="mb-0">{t(`layout.pageTexts.dashboard.pageTexts.currentMonthStats.labels.${item.label.toLowerCase()}`)}</p>
              </div>
            </div>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthStatCard;

